export default __webpack_public_path__ + "static/media/icon03.8de24367.svg";